// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: inline-flex;
  margin-left: auto;
  padding-left: 12px;
}

.developer-measure-override {
  min-width: 30px;
  height: 20px;
  padding: 0 5px;
  border: 1px solid rgba(255, 255, 255, 0.65);
  border-radius: 3px;
  background: transparent;
  color: rgba(255, 255, 255, 0.75);
  cursor: pointer;
  font: 700 9px/18px Arial, sans-serif;
  letter-spacing: 0.4px;
}

.developer-measure-override:hover,
.developer-measure-override-active {
  background: #f59e0b;
  border-color: #f59e0b;
  color: #111827;
}

.developer-measure-override:disabled {
  cursor: default;
  opacity: 0.45;
}
`, "",{"version":3,"sources":["webpack://./projects/cemsys/src/app/project-details/slurry-details/popups/developer-measure-override/developer-measure-override.component.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,2CAA2C;EAC3C,kBAAkB;EAClB,uBAAuB;EACvB,gCAAgC;EAChC,eAAe;EACf,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,aAAa;AACf","sourcesContent":[":host {\n  display: inline-flex;\n  margin-left: auto;\n  padding-left: 12px;\n}\n\n.developer-measure-override {\n  min-width: 30px;\n  height: 20px;\n  padding: 0 5px;\n  border: 1px solid rgba(255, 255, 255, 0.65);\n  border-radius: 3px;\n  background: transparent;\n  color: rgba(255, 255, 255, 0.75);\n  cursor: pointer;\n  font: 700 9px/18px Arial, sans-serif;\n  letter-spacing: 0.4px;\n}\n\n.developer-measure-override:hover,\n.developer-measure-override-active {\n  background: #f59e0b;\n  border-color: #f59e0b;\n  color: #111827;\n}\n\n.developer-measure-override:disabled {\n  cursor: default;\n  opacity: 0.45;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
